<template>
  <div>
    <Loader :messageSelector="messageSelector" :overlay="overlay" />
    <v-form ref="form" v-model="valid">
      <fieldset>
        <legend class="text-h6 text-sm-h5">Préférences de communication</legend>
        <!-- Question 1 communications promotionnelles -->
        <div>
          <p class="mentionLegal">
            En plus des communications essentielles, j'accepte de recevoir les communications en provenance de l'Ordre (par exemple : les Infolettres,
            les messages destinés aux membres...)
          </p>
          <v-autocomplete
            v-model="transmissionOrdre.communicationsPromotionnelles"
            :item-text="itemText"
            :item-value="itemValue"
            :items="listesCommunicationsTiers"
            :rules="rules.requis"
            class="cssRequired"
            label="Réponse"
            required
            return-object
          />
        </div>
        <!-- Question 2 communications promotionnelles partenaires -->
        <div>
          <p class="mentionLegal">
            J'accepte de recevoir les communications promotionnelles transmises par l'Ordre pour le compte de partenaires (offres de formation, offres
            d'emploi, services, etc.).
          </p>
          <v-autocomplete
            v-model="transmissionOrdre.communicationsPromotionnellesPartenaires"
            :item-text="itemText"
            :item-value="itemValue"
            :items="listesCommunicationsTiers"
            :rules="rules.requis"
            class="cssRequired"
            label="Réponse"
            required
            return-object
          />
        </div>
        <!-- Question 3 communique mes renseignements professionnels -->
        <div>
          <p class="mentionLegal">
            J'accepte que l'Ordre communique mes renseignements professionnels à caractère public à une personne ou à une organisation qui souhaite
            utiliser ces renseignements à des fins d'étude, de recherche ou de production de statistiques.
          </p>
          <v-autocomplete
            v-model="transmissionOrdre.communicationsRenseignementsProfessionnels"
            :item-text="itemText"
            :item-value="itemValue"
            :items="listesCommunicationsTiers"
            :rules="rules.requis"
            class="cssRequired"
            label="Réponse"
            required
            return-object
          />
        </div>
        <!-- Information ententes commerciales -->
        <div>
          <p class="mentionLegal">
            J'accepte que l'Ordre communique mes nom, adresse, numéro de téléphone et adresse courriel aux organisations suivantes avec lesquelles il
            a conclu des ententes commerciales à l'intention de ses membres :
          </p>
        </div>
        <!-- Question 4 Assurance personnelle -->
        <div class="ml-8">
          <p class="mentionLegal">
            - Assurance La Personnelle et ses tiers fournisseurs de services (afin de vous faire parvenir de l'information sur ses produits d'assurance 
              et sur le tarif préférentiel d'assurance groupe négocié par l'Ordre pour l'assurance automobile 
              et habitation ou sur tout autre élément de son programme d’assurance).
          </p>
          <v-autocomplete
            v-model="transmissionOrdre.assuranceLaPersonnelle"
            :item-text="itemText"
            :item-value="itemValue"
            :items="listesTypesMandatsBottin"
            :rules="rules.requis"
            class="cssRequired"
            label="Réponse"
            required
            return-object
          />
        </div>
      </fieldset>
    </v-form>

    <div class="justify-end">
      <v-btn color="primary" :disabled="!valid" @click="saveAndExit()">Sauvegarder et fermer</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import Loader from "../Loader"
import { getExtranetUrl } from "@/utils/stringUtils"

export default {
  props: {
    routeName: {
      type: String,
      default: ""
    }
  },
  components: {
    Loader: Loader
  },
  data() {
    return {
      messageSelector: "",
      overlay: false,
      valid: false,
      rules: {
        requis: [(v) => !!v || "Cette valeur est requise"]
      }
    }
  },
  computed: {
    ...mapGetters({
      contactId: "Unitaire/GET_CONTACTID",
      transmissionOrdre: "TransmissionOrdre/GET_TRANSMISSIONORDRE",
      listesCommunicationsTiers: "Catalogue/GET_COMMUNICATIONSTIERS",
      listesTypesMandatsBottin: "Catalogue/GET_TYPESMANDATSBOTTIN"
    })
  },
  async created() {
    await this.fetchItems()
  },
  methods: {
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue",
      getTransmissionOrdreByContactId: "TransmissionOrdre/getTransmissionOrdreByContactId",
      createTransmissionOrdre: "TransmissionOrdre/createTransmissionOrdre"
    }),
    async fetchItems() {
      try {
        this.messageSelector = "Loading"
        this.overlay = true

        const requests = [
          this.getCatalogue(this.$cataloguesDesc.communicationsTiers),
          this.getCatalogue(this.$cataloguesDesc.communicationsTypesBottin)
        ]

        requests.push(this.getTransmissionOrdreByContactId(this.contactId))

        await Promise.all(requests)

        this.validateForm(true)
        this.overlay = false
      } catch (erreur) {
        console.log(erreur)
      }
    },
    async save() {
      this.validateForm()

      if (this.valid) {
        this.messageSelector = "Save"
        this.overlay = true

        // Suppression des id pour produire la création d'une nouvelle fiche
        this.transmissionOrdre.id = null
        this.transmissionOrdre.demandeAdmission = null
        this.transmissionOrdre.demandeInscription = null
        this.transmissionOrdre.active = true

        await this.createTransmissionOrdre(this.transmissionOrdre)

        this.redirect()
      }
    },
    itemText: (item) => item.lang00,
    itemValue: (item) => item.id,
    validateForm(resetValidation = false) {
      this.valid = this.$refs.form?.validate() || false

      if (resetValidation) {
        this.$refs.form?.resetValidation()
      }
    },
    async saveAndExit() {
      await this.save()
    },
    redirect() {
      window.top.location.href = getExtranetUrl(process.env.VUE_APP_PROFIL_XTRANET)
    }
  }
}
</script>

<style></style>